import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '@/components/common/ComingSoon';
import * as m from '@/paraglide/messages.js';

export const Route = createFileRoute('/{-$locale}/hospitals/')({
  component: HospitalsPage,
});

function HospitalsPage() {
  return <ComingSoon title={m.page_companies()} />;
}
